module.exports = __webpack_public_path__ + "static/media/4-outdoor.1ab8f2d0.webp";